
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"7dc5f9daa23d9a09bde025607867b6bc231593c8":"$$ACTION_0","ab0ef17417bb40b231c2fd806db9bd30b56716c9":"getServerMetrics"} */ export var getServerMetrics = createServerReference("ab0ef17417bb40b231c2fd806db9bd30b56716c9");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

